<template>
<div id="app">
    <div class="backtop">
        <router-view />
    </div>
    <TheBacktop />
</div>
</template>

<script>
import TheBacktop from "@/components/TheBacktop";
export default {
    name: 'App',
    components: {
        TheBacktop,
    },
}
</script>

<style>
.backtop {
    overflow: auto;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue